import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { message, Divider } from 'antd'
import InfiniteScroll from 'react-infinite-scroll-component'

import { useTelegramAccounts as useTelegramAccountsV2 } from '../../hooks/useTelegramAccounts'
import { ListPageHeader } from '../../components/ListPageHeader'
import TelegramAccountsList from '../../components/TelegramAccountsList/TelegramAccountsList.component'
import './TelegramAccountsListPage.styles.css'

const TelegramAccountsListPage: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchValue, setSearchValue] = useState('')

  const { items, isLoading: loading, initialLoading, error, search: searchQuery, loadInitial, loadMore, refresh, onSearch, hasMore: hasNextPage } = useTelegramAccountsV2({ perPage: 12 })

  useEffect(() => {
    loadInitial()
  }, [loadInitial])

  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearchValue(value)
    onSearch(value)
  }, [onSearch])

  const handleCreateButtonClick = () => {
    navigate('/telegram_accounts/create')
  }

  const handleAccountUpdated = useCallback(async () => {
    try {
      await refresh()
    } catch (err) {
      console.error('Failed to refresh accounts:', err)
      message.error(t('error-refreshing-accounts', { ns: 'errors' }))
    }
  }, [refresh, t])

  const handleCloseError = () => {}

  const renderError = () => {
    if (!error) return null

    return (
      <div className="telegram-accounts-list-page__error">
        <span>{error}</span>
        <button 
          className="telegram-accounts-list-page__error-close"
          onClick={handleCloseError}
          aria-label="Закрыть"
        >
          ×
        </button>
      </div>
    )
  }

  return (
    <div className="telegram-accounts-list-page">
      <ListPageHeader
        title={t('telegram-accounts', { ns: 'standard' })}
        subtitle={t('telegram-accounts-management', { ns: 'standard' })}
        searchPlaceholder={t('search-telegram-accounts', { ns: 'standard' })}
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        createButtonText={t('create-telegram-account', { ns: 'standard' })}
        onCreateClick={handleCreateButtonClick}
        loading={loading}
      />

      <div className="telegram-accounts-list-page__content">
        <div 
          id="scrollableDiv"
        >
          {renderError()}
          <InfiniteScroll
            dataLength={items.length}
            next={loadMore}
            hasMore={hasNextPage}
            loader={
              <div style={{ 
                textAlign: 'center', 
                padding: '20px 0'
              }}>
                <div style={{ 
                  width: '32px', 
                  height: '32px', 
                  border: '3px solid #f3f3f3',
                  borderTop: '3px solid #0d6efd',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  margin: '0 auto'
                }} />
              </div>
            }
            endMessage={loading || <Divider plain>{t('there-is-nothing-more', {ns: 'standard'})}</Divider>}
            scrollableTarget="scrollableDiv"
          >
            <TelegramAccountsList accounts={items} isLoading={initialLoading} onAccountUpdated={handleAccountUpdated} searchQuery={searchQuery} />
          </InfiniteScroll>
        </div>
      </div>
    </div>
  )
}

export default TelegramAccountsListPage
